import React from "react";
import {useDispatch, useSelector} from "react-redux";

import * as modalActions from "../../../store/actions/modal";
import * as actionTypes from '../../../store/actions/actionTypes';
import {useCustomLogic} from "../../../utils/customLogic";

const AdmissionList_Item_OEC = ({admission}) => {
    const dispatch = useDispatch();
    const manager_noMbsUi = useSelector(state => state.auth.manager_noMbsUi);
    const {isCustomLogicLifehouse, isCustomLogicStLuke} = useCustomLogic();

    const showModal = event => {
        event.preventDefault();
        event.stopPropagation();
        console.log('[AdmissionList_Item_OEC] showModal()', admission.eclipseModalBc);
        dispatch(modalActions.showOecForAdmission(admission));
    }
    const doNothing = event => {
        event.preventDefault();
        event.stopPropagation();
    }
    const showCustomMBSModal = event => {
        event.preventDefault();
        event.stopPropagation();
        if (manager_noMbsUi) {
            console.log('[AdmissionList_Item_OEC] showModal()');
            dispatch({type: actionTypes.MODAL_PRESENTING_ILLNESS_CODES_SHOW, admission: admission});
        }
    }

    const codesCount = admission.illCodes_count ? admission.illCodes_count : admission.mbsCodes_count;

    if (isCustomLogicLifehouse && admission.lifehouse_erfaFundingType === "LIFEHOUSE_FUNDING_PUBLIC") {
        return (
            <div className="d-flex flex-nowrap align-items-center" onClick={doNothing}>
                <button className="btn btn-sm btn-secondary">Public</button>
            </div>
        );
    }

    switch (admission.statusOECStr) {
        case "STATUS_OEC_MISSING_DATA":
            if (admission.adm2_fund && (admission.fundMemberNo || admission.adm2_membershipNumber) && !admission.mbsCodes_count) {
                return (
                    <div className="d-flex flex-nowrap align-items-center" onClick={showCustomMBSModal}>
                        <button className="btn btn-sm btn-danger">No MBS</button>
                        <span className="info-tooltip" data-tip="MBS is not assigned for this admission">
                            <i className="icon ico-c-info"/>
                        </span>
                    </div>
                );
            } else {
                return (
                    <div className="d-flex flex-nowrap align-items-center" onClick={doNothing}
                         data-tip="Health Fund Info is not assigned for this admission"
                    >
                        <button className="btn btn-sm btn-danger">No HFI</button>
                        <span className="info-tooltip">
                            <i className="icon ico-c-info"/>
                        </span>
                    </div>
                );
            }
        case "STATUS_OEC_MODERATION":
            return (
                <div className="d-flex flex-nowrap align-items-center">
                    <button className="btn btn-sm btn-warning" onClick={showModal}>Moderation</button>
                </div>
            );
        case "STATUS_OEC_COMPLETED":
            switch (admission.statusFundingStr) {
                case "STATUS_FUND_WARNING":
                    return <_Button
                                showModal={showModal}
                                label="Warning"
                                date={admission.oec_completedAt}
                                btnStyle="btn-warning"
                            />
                case "STATUS_FUND_REJECTED":
                    return <_Button
                                showModal={showModal}
                                label="Rejected"
                                date={admission.oec_completedAt}
                                btnStyle="btn-danger"
                            />
                case "STATUS_FUND_ACCEPTED":
                    return <_Button
                                admission={admission}
                                showModal={showModal}
                                label={`Done ${codesCount}/${codesCount}`}
                                date={admission.oec_completedAt}
                            />
                default:
                    return;
            }
        case "STATUS_OEC_IN_PROGRESS":
        case "STATUS_OEC_PENDING":
            return <_Button
                admission={admission}
                showModal={showModal}
                label={`Processing`}
                // date={admission.oec_scheduleDate}
                btnStyle='btn-warning'
            />
        case "STATUS_OEC_FAILED":
            return (
                <_Button
                    admission={admission}
                    showModal={showModal}
                    label={`Failed`}
                    date={admission.oec_lastRequest}
                    btnStyle='btn-danger'
                />
            );
        case "STATUS_OEC_NOT_SUPPORTED":
            return (
                <div className="d-flex flex-nowrap align-items-center" onClick={doNothing}>
                    <button className="btn btn-sm btn-secondary" onClick={doNothing}>-</button>
                    <span className="info-tooltip"
                          data-tip="OEC checks are supported only for private insurance">
						<i className="icon ico-c-info" />
					</span>
                </div>
            );
        case "STATUS_OEC_SCHEDULED":
            return <_Button
                admission={admission}
                showModal={showModal}
                label={`Scheduled`}
                date={admission.oec_scheduleDate}
                btnStyle='btn-secondary'
            />
        default:
            // TODO: Watch logical errors in react
            return null;
    }
}

const _Button = ({showModal, label, date, btnStyle = 'btn-success'}) => {
    return (
        <div className="d-flex flex-nowrap align-items-center">
            <div className="d-flex flex-column align-items-center">
                <button className={`btn btn-sm ${btnStyle}`} onClick={showModal}>{label}</button>
                {date && <small className="text-muted" style={{fontSize: '0.7rem'}}>{date}</small>}
            </div>
        </div>
    )
}

export default AdmissionList_Item_OEC;